// Lucian UX/UI Prompt #079 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#079
// 最初の読み込みの骨組み。光の筋が1本流れる。読み込み直しでは使わない（前の表示を薄くして残す。dataviz）。
import React from 'react';
import './lucian.css';

export default function Skeleton({ blocks = [[120, 20], [56, 80], [300, 100]] }) {
  return (
    <div className="lx" aria-busy="true" aria-label="読み込み中">
      {blocks.map(([h, w], i) => (
        <div key={i} className="lx-card">
          <div className="lx-skel" style={{ height: 14, width: '30%', marginBottom: 12 }} />
          <div className="lx-skel" style={{ height: h, width: `${w}%` }} />
        </div>
      ))}
    </div>
  );
}
